<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Project/POA/components/Bitacora/Recap'
    export default {
        components: {
            Grid,
        }
    }
</script>